module.exports = __webpack_public_path__ + "static/media/filled-left-arrow.c49711d9.svg";